import type { TFunction } from 'i18next';
import type { ApiError } from '@aiia/portal-core';

export function getApiErrorMessage(error: unknown, t: TFunction): string {
  const apiError = error as ApiError;
  const code = apiError?.code;

  if (code) {
    const translated = t(`errors.${code}`, {
      defaultValue: '',
      ...(apiError?.details || {}),
    });
    if (translated) {
      return translated;
    }
  }

  return apiError?.message || t('errors.UNEXPECTED_ERROR');
}
